/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconPlusFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlusFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM7 4a1 1 0 0 1 2 0v3h3a1 1 0 1 1 0 2H9v3a1 1 0 1 1-2 0V9H4a1 1 0 1 1 0-2h3V4Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconPlusFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlusFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-5.5-9a1 1 0 1 1 0-2H11V6.5a1 1 0 1 1 2 0V11h4.5a1 1 0 1 1 0 2H13v4.5a1 1 0 1 1-2 0V13H6.5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconPlusFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlusFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconPlusFilled16 {...iconProps} />;
        case '24':
            return <IconPlusFilled24 {...iconProps} />;
        default:
            return <IconPlusFilled24 {...iconProps} />;
    }
});
